import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../../Components/SideBar/sideBar';
import Header from '../../Components/Header/header';
import { changeCardFalse } from '../../Redux/store/selectedCard';
import { useDispatch, useSelector } from 'react-redux';
import ChatWidgetIframe from '../../Components/Chat/chat-widget';
import useAutoLogout from '../../Components/custom-logout/custom-logout';
import { logout as logoutTokenManager } from '../../Utils/tokenManager';
import { setIsBack } from '../../Redux/store/userSlice';
const AdminDashboard = ({ children }) => {
  const [selectedMenuId, setSelectedMenuId] = useState(1);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 1024 ? true : false,
  );
  const roleName = useSelector((state) => state.user.roleName);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollRef = useRef(null);
  const chatRef = useRef(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [hideChat, setHideChat] = useState(false);
  const showPopup = useSelector((state) => state.form.showPopup);
  const logout = () => {
    logoutTokenManager();
  };
  const token = localStorage.getItem('jwtToken');
  const userStatus = useSelector((state) => state.user.userStatus);
  const forcedPassword = useSelector((state) => state.user.forcedPassword);
  const hasPendingTraining = useSelector(
    (state) => state.user.hasPendingTraining,
  );
  const eddStatus = useSelector((state) => state.user.eddStatus);
  const surveyPending = useSelector((state) => state.user.surveyStatus);
  // useEffect(() => {
  //   console.log("Checking authentication and user status..."+userStatus);
  //     const expired = localStorage.getItem("sessionExpired");

  //    if (!localStorage.getItem("jwtToken")) {
  //     navigate("/login");
  //     return;
  //   }
  //  if (expired) {
  //     localStorage.removeItem("sessionExpired");

  //     // optional: keep redirect
  //     navigate("/login", {
  //       state: { sessionExpired: true },
  //     });
  //     return;
  //   }
  //   if (forcedPassword) {
  //     navigate("/forgot-password");
  //     return;
  //   }

  //   if ((roleName == "agent" ||
  //                 roleName == "agency_compliance") &&hasPendingTraining) {
  //     navigate("/training");
  //     return;
  //   }
  //    if (eddStatus) {
  //     navigate("/edd");
  //     return;
  //   }

  //   if (roleName === "agency" && surveyPending) {
  //     navigate("/survey");
  //     return;
  //   }

  //  const saved = sessionStorage.getItem("redirectAfterLogin");

  //   if (saved) {
  //     const { path, state } = JSON.parse(saved);
  //     sessionStorage.removeItem("redirectAfterLogin");
  //     navigate(path, { state });
  //     return;
  //   }

  //   if (userStatus === "active") {
  //     navigate("/");
  //   } else {
  //     navigate("/onboarding");
  //   }

  // }, [
  //   token,
  //   userStatus,
  //   eddStatus,
  //   surveyPending,
  // ]);
  useAutoLogout(logout);

  // Track viewport size so layout adapts on resize / orientation change
  useEffect(() => {
    let frame = null;
    const handleResize = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const mobile = window.innerWidth <= 1024;
        setIsMobile(mobile);
        // Auto-close the drawer when switching to desktop
        if (!mobile) setIsMenuOpen(false);
      });
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  // Lock body scroll while mobile drawer is open
  useEffect(() => {
    if (isMobile && isMenuOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [isMobile, isMenuOpen]);

  const handleMenuChange = (menuId) => {
    setSelectedMenuId(menuId);
    let routes = {};
    if (roleName == 'customer') {
      // Navigate to different routes based on menu selection
      routes = {
        1: '/',
        2: '/my-profile',
        3: '/support-tickets',
        4: '/my-contracts',
      };
    }
    if (roleName == 'agency') {
      // Navigate to different routes based on menu selection
      routes = {
        1: '/',
        2: '/my-profile',
        3: '/customer-list',
        4: '/customer-list',
        5: '/compliance-officer',
        6: '/risk-assessment',
        // 7: '/survey-list',
        8: '/support-tickets',
        // 9: '/document-management',
        10: '/my-pricing-plan',
        // 11: '/auditor-list',
        // 12: '/role-permission-settings',
        13: '/certificates',
        14: '/members',
      };
    }
    if (roleName == 'agency_compliance') {
      // Navigate to different routes based on menu selection
      routes = {
        1: '/',
        2: '/my-profile',
        3: '/team-member-list',
        4: '/customer-list',
        5: '/risk-assessment',
        6: '/survey-list',
        7: '/training',
        8: '/monitoring',
        9: '/support-tickets',
        10: '/generate-report',
      };
    }
    if (roleName == 'auditor') {
      // Navigate to different routes based on menu selection
      routes = {
        1: '/',
        2: '/my-profile',
        3: '/team-member-list',
        4: '/customer-list',
        5: '/compliance-officer',
        6: '/survey-list',
        7: '/training',
        8: '/monitoring',
        9: '/support-tickets',
        10: '/generate-report',
      };
    }
    if (roleName == 'business') {
      // Navigate to different routes based on menu selection
      routes = {
        1: '/',
        2: '/my-profile',
        3: '/customer-list',
        4: '/business-owner-list',
        5: '/support-tickets',
      };
    }
    if (roleName == 'agent') {
      // Navigate to different routes based on menu selection
      routes = {
        1: '/',
        2: '/my-profile',
        3: '/customer-list',
        4: '/training',
        5: '/support-tickets',
        6: '/template-management',
        7: '/create-contract',
      };
    }
    if (menuId == 1) {
      dispatch(changeCardFalse());
    }
    const targetRoute = routes[menuId];

    let redirectState = {
      path: targetRoute,
      state: {
        from: location.pathname,
      },
    };
    sessionStorage.setItem('redirectAfterLogin', JSON.stringify(redirectState));
    const newHistoryStack = [
      ...(location.state?.historyStack || []),
      location.pathname,
    ];

    navigate(targetRoute, {
      state: {
        from: location.pathname,
        historyStack: newHistoryStack,
      },
    });
  };
  // Show button after scrolling 100px
  useEffect(() => {
    const handleScroll = () => {
      console.log('I am main scrolling');
      setShowScrollTop(window.scrollY > 60);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  useEffect(() => {
    if (!chatRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const isIntersecting = entries.some((entry) => entry.isIntersecting);
        setHideChat(isIntersecting);
      },
      { threshold: 0.1 },
    );

    const attachObservers = () => {
      observer.disconnect();
      const targets = document.querySelectorAll('.bottom-actions-save');
      targets.forEach((el) => observer.observe(el));
    };

    // Attach when popup changes
    attachObservers();

    // Optional: Watch DOM for dynamic additions
    const mutationObserver = new MutationObserver(attachObservers);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [showPopup]); // <-- re-run whenever popup is shown/hidden

  // Hide the scroll-to-top button while any bottom action bar
  // (Submit / Continue / Back To Login footer) is visible on screen,
  // so the button never overlaps those buttons.
  const [actionBarVisible, setActionBarVisible] = useState(false);
  useEffect(() => {
    const SELECTOR =
      '.bottom-actions, .bottom-actions-save, footer.bg-\\[\\#375AE7\\]';
    const visible = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        setActionBarVisible(visible.size > 0);
      },
      { threshold: 0 },
    );

    const attach = () => {
      observer.disconnect();
      visible.clear();
      const targets = document.querySelectorAll(SELECTOR);
      if (targets.length === 0) setActionBarVisible(false);
      targets.forEach((el) => observer.observe(el));
    };

    attach();
    const mutationObserver = new MutationObserver(attach);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [location.pathname, showPopup]);

  return (
    <div className="flex bg-[#F0F0F0] min-h-screen w-full max-w-full overflow-x-hidden">
      {/* Mobile backdrop – closes drawer on tap */}
      {isMobile &&
        isMenuOpen &&
        location.pathname != '/onboarding' &&
        location.pathname != '/edd' &&
        location.pathname != '/survey' &&
        !location.pathname.startsWith('/edd') &&
        !location.pathname.startsWith('/onboarding-shareholder') && (
          <div
            className="fixed inset-0 bg-black/40 backdrop-blur-[2px] z-[9] transition-opacity duration-300"
            onClick={() => setIsMenuOpen(false)}
            aria-hidden="true"
          />
        )}
      {location.pathname != '/onboarding' &&
        location.pathname != '/edd' &&
        location.pathname != '/survey' &&
        !location.pathname.startsWith('/edd') &&
        !location.pathname.startsWith('/onboarding-shareholder') && (
          <Sidebar
            toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
            isMenuOpen={isMenuOpen}
            isMobile={isMobile}
            onSideMenupChange={handleMenuChange}
          />
        )}

      <div
        className={`flex flex-col flex-grow min-w-0 w-full overflow-x-hidden ${
          isMobile
            ? isMenuOpen
              ? 'opacity-30 overflow-hidden pointer-events-none'
              : 'opacity-100 overflow-auto'
            : 'opacity-100 overflow-auto'
        }`}
      >
        {location.pathname != '/onboarding' &&
          !location.pathname.startsWith('/onboarding-shareholder') && (
            <Header
              toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
              isMenuOpen={isMenuOpen}
              isMobile={isMobile}
              currentScreen={location.pathname}
              onBack={() => {
                //   navigate(-1);
                //   navigate(location.state?.from || "/");
                const stack = location.state?.historyStack || [];
                if (stack.length > 0) {
                  const previous = stack[stack.length - 1];
                  const newStack = stack.slice(0, -1);

                  navigate(previous, {
                    state: {
                      historyStack: newStack,
                    },
                  });
                } else {
                  navigate('/');
                }
              }}
            />
          )}
        <div className="flex flex-col flex-grow min-w-0 w-full overflow-x-hidden px-2 sm:px-3 md:px-0">
          {children}
          <footer className="w-full mt-auto">
            <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-8 py-3 sm:py-4 flex flex-col md:flex-row items-center justify-between gap-3">
              {/* LEFT TEXT */}
              <p className="text-xs md:text-sm text-gray-600 text-center md:text-left">
                Please see our{' '}
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/privacy-policy');
                  }}
                  className="text-blue-600 font-medium hover:underline cursor-pointer"
                >
                  Privacy Policy
                </span>{' '}
                for information about how we process your data.
              </p>
            </div>
          </footer>
          {showScrollTop && !actionBarVisible && (
            <button
              onClick={scrollToTop}
              aria-label="Scroll to top"
              className={`
                ${isMobile ? 'bottom-20 right-3 h-11 w-11' : 'bottom-[4.5vw] right-4 h-12 w-12'}
              font-medium fixed z-50 flex items-center justify-center bg-[#375AE7] text-white rounded-full shadow-lg hover:bg-gray-800`}
            >
              ↑
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
